export default class videoPlayer {
    constructor() {
        videoPlayer.overlayClick()
    }

    static overlayClick() {
        const element = "[data-element='player-video']"

        $(document).on('click', element, function (e) {
            $(this).fadeOut()
            const mediaParent = $(this).parent()

            if (mediaParent) {
                videoPlayer.playMedia(mediaParent)
            }
        })
    }

    static playMedia(mediaParent) {
        const mediaVideo = $(mediaParent).find('video')
        const mediaIframe = $(mediaParent).find('iframe')

        // Video mp4
        if (mediaVideo.length > 0) {
            mediaVideo[0].play()
        }

        // Video iframe
        if (mediaIframe.length > 0) {
            if (mediaIframe[0].src.startsWith('https://www.youtube.com')) {
                mediaIframe[0].contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    '*',
                )
            }

            if (mediaIframe[0].src.startsWith('https://player.vimeo.com')) {
                mediaIframe[0].contentWindow.postMessage('{"method":"play"}', '*')
            }

            if (mediaIframe[0].src.startsWith('https://www.dailymotion.com')) {
                mediaIframe[0].contentWindow.postMessage('{"command":"play","parameters":[]}', '*')
            }
        }
    }
}
